// @ts-strict
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LMReportFieldPickerService } from './lm-report-field-picker.service';
import { Observable } from 'rxjs';
import { ReportFieldPickerConstants } from './lm-report-field-picker.constants';
import { LMModel } from '@app/components/form';
import { LMFormatUtilService } from '@app/services';

@Component({
  selector: 'lm-report-field-picker-button',
  templateUrl: './lm-report-field-picker-button.component.html',
  styleUrls: ['./lm-report-field-picker-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMReportFieldPickerButtonComponent implements OnInit {
  @Input() field!: LMFormLayoutField;
  @Input() specFields: LMSpecFields;
  @Input() model: LMModel;

  readonly ButtonConstants = ReportFieldPickerConstants.Button;

  selectedFields$!: Observable<Map<string, string>>;
  isCreateReportMode$!: Observable<boolean>;

  constructor(private lmReportFieldPickerService: LMReportFieldPickerService, private lmFormatUtilService: LMFormatUtilService) {}

  ngOnInit(): void {
    this.selectedFields$ = this.lmReportFieldPickerService.selectedFields$;
    this.isCreateReportMode$ = this.lmReportFieldPickerService.isCreateReportMode$;
  }

  onAddField = () => {
    const id = this.field.bindId;
    const labelLayoutObject = this.field.label as LMLabelLayout;
    const messageRuleObject = labelLayoutObject?.label as LMMessageRule;
    let label = messageRuleObject?.resourceValue || '';
    
    if (messageRuleObject?.variables?.length) {
      label = this.lmFormatUtilService.formatMessageRule(messageRuleObject, this.model, this.specFields);
    }

    if (id) {
      this.lmReportFieldPickerService.addField(id, label);
    }
  };

  onRemoveField = () => {
    const id = this.field.bindId;
    if (id) {
      this.lmReportFieldPickerService.removeField(id);
    }
  };
}
